import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { ServerCommunicationModule } from '../server-communication/server-communication.module';
import { TimeDisplayModule } from '../time-display/time-display.module';
import { FooterMenuComponent } from './footer-menu/footer-menu.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { NavigationService } from './navigation.service';

@NgModule({
    declarations: [HeaderMenuComponent, FooterMenuComponent],
    imports: [CommonModule, RouterModule, MaterialModule, TimeDisplayModule, ServerCommunicationModule],
    exports: [HeaderMenuComponent, FooterMenuComponent],
    providers: [NavigationService]
})
export class NavigationModule {}
